import styled from 'styled-components';

const StyledNavbarBadge = styled.span `
    display: inline-flex;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    box-sizing: border-box;
    vertical-align: baseline;
    border-radius: 99px;
    flex: 0 0 24px;
    background-color: ${({ $isDark }) => ($isDark ? '#D1D5DB' : '#374151')};
    color: ${({ $isDark }) => ($isDark ? '#1F2937' : '#f3f4f6')};
    margin-left: 6px;
`;

export { StyledNavbarBadge };
//# sourceMappingURL=NavbarBadge.styles.js.map
